module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.name }} - {{ settings.app.versao }}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = ./src/app/layout/footer/footer.component.html
// module chunks = main